import { Link } from 'react-router-dom';
import { Activity, ArrowRight, Compass, ShieldCheck, Target } from 'lucide-react';
import { AMDEN_SYSTEMS, SYSTEMS_SECTION } from '@/data/operations';
import { SectionHeader } from '../SectionHeader';
import { ServiceMark } from '../AmdenMark';
import { Reveal } from '../Reveal';

const SYSTEM_ICONS = {
  compass: Compass,
  activity: Activity,
  'shield-check': ShieldCheck,
  target: Target,
};

const SystemCard = ({ system, index }) => {
  const Icon = SYSTEM_ICONS[system.icon];
  return (
    <Reveal delay={index * 0.08} className="h-full">
      <article
        data-testid={`system-card-${system.slug}`}
        data-system-slug={system.slug}
        data-purchasable={system.purchasable}
        className="group flex h-full flex-col rounded-xl border border-white/10 bg-navy-800/60 p-7 transition-[border-color,background-color,transform] duration-300 hover:-translate-y-1 hover:border-gold-600/40 hover:bg-navy-800"
      >
        <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-gold-600/15 text-gold-500">
          <Icon className="h-6 w-6" aria-hidden="true" />
        </span>
        <h3 className="mt-5 text-lg font-extrabold tracking-tight text-white">{system.name}</h3>
        <p className="mt-3 text-sm leading-relaxed text-slate-300">{system.purpose}</p>
        <Link
          to={system.href}
          data-testid={`system-learn-more-${system.slug}`}
          className="mt-auto inline-flex items-center gap-1.5 pt-6 text-sm font-bold text-gold-500 transition-colors hover:text-gold-200"
        >
          Learn more
          <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" />
        </Link>
      </article>
    </Reveal>
  );
};

export const SystemsSection = () => (
  <section
    aria-labelledby="systems-heading"
    data-testid="systems-section"
    className="relative overflow-hidden bg-navy-900 py-20 sm:py-28"
  >
    <div className="grain-overlay" aria-hidden="true" />
    <ServiceMark color="#ffffff" className="pointer-events-none absolute -right-12 -top-12 h-56 w-56 opacity-[0.05]" />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeader
        index="04"
        eyebrow={SYSTEMS_SECTION.eyebrow}
        title={SYSTEMS_SECTION.heading}
        description={SYSTEMS_SECTION.intro}
        dark
        testid="systems-header"
      />
      <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {AMDEN_SYSTEMS.map((system, i) => (
          <SystemCard key={system.slug} system={system} index={i} />
        ))}
      </div>
    </div>
  </section>
);
